import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler, Controller, set } from 'react-hook-form';
import Input from '../../../components/elements/form/input';
import SelectBox from '../../../components/elements/form/selectBox';
import Button from '../../../components/elements/button';
import qrImg from '../../../images/facility-qr.jpg';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import toast from 'react-hot-toast';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';
import { useAppLoader } from '../../../_common/pageLoader/appLoaderHook';
import { getSelectedOption, getSelectedOptions } from '../../../_common/functions';
import FileUpload from '../../../components/elements/form/fileUplaod';
import { Option } from '../../../_config/types';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

import { useElectricityProvidersSelector, useFacilityManagersSelector, useGasProvidersSelector, useServiceTechsSelector, useStatesSelector, useTeamsSelector, useTelephoneProvidersSelector, useWaterProvidersSelector } from '../../../store/selectors/masterSelector';
import { MAP_KEY } from '../../../_config';
import Label from '../../../components/elements/form/fromLabel';
import Error from '../../../components/elements/form/fromError';

import { GoogleMap, LoadScript, Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { useSagesApi } from '../../../store/api/hooks/sageApiHook';
import { useVendorsApi } from '../../../store/api/hooks/vendorsApiHook';

interface Props {
    editID?: any
    onCreate?: () => void
    onCancel?: () => void
    _ref?: any
}

type FormValues = {
    facilityName: string,
    processingFacilityID: any,
    addressLine1: any,
    addressLine2: string,
    stateID: any,
    countyID: any,
    cityID: any,
    zipCode: any,
    area: any,
    taxMapImage: any,
    noOfRanches: any,
    facilityManagerList: any,
    facilityServiceTechList: any,
    facilityTeamList: any,
    electricityVendorServiceTypeID: any,
    natGasVendorServiceTypeID: any,
    waterAuthrityVendorServiceTypeID: any,
    isP_TelephoneVendorServiceTypeID: any,
    purchaseDate: Date;
    sageFacilityID: any;
};

const CreateFacilities: React.FC<Props> = ({ _ref, editID, onCreate = () => { }, onCancel = () => { } }) => {
    const { isLoaded } = useJsApiLoader({
        id: 'facility-map-script',
        googleMapsApiKey: MAP_KEY,
        libraries: ['places'],
    });

    const { showLoader, hideLoader } = useAppLoader()
    const facilityApi: any = useFacilitiesApi();
    const commonApi: any = useCommonApi();
    const sageApi: any = useSagesApi();
    const vendorApi = useVendorsApi();

    const [editData, setEditData] = useState<any>(null);
    const [latitude, setLatitude] = useState<any>(null);
    const [longitude, setLongitude] = useState<any>(null);

    const states: Option[] | null = useStatesSelector();
    const users = useFacilityManagersSelector();
    const teams = useTeamsSelector();
    const servicetech = useServiceTechsSelector();
    const electricity = useElectricityProvidersSelector();
    const gas = useGasProvidersSelector();
    const water = useWaterProvidersSelector();
    const telephone = useTelephoneProvidersSelector();

    const [facilityManagers, setFacilityManagers] = useState<any>(null);

    useEffect(() => {
        if (states == null) {
            commonApi.GetStateList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [states])

    useEffect(() => {
        if (facilityManagers == null) {
            facilityApi.getFacilityManagerList({
                pageNo: 1,
                pageSize: 1000
            }, (resp: any) => {
                let facilityManagerOptions: any = [];
                resp.facilityList?.map((manager: any) => {
                    facilityManagerOptions.push({
                        label: manager.name,
                        value: manager.facilityManagerMasterId,
                        data: manager
                    });
                });
                setFacilityManagers(facilityManagerOptions);
            }, (error: any) => {
                toast.error(error);
            })
        }
    }, [facilityManagers])

    useEffect(() => {
        if (teams == null) {
            commonApi.GetteamList({
                pageNo: 1,
                pageSize: 1000
            }, (resp: any) => { }, (error: any) => { })
        }
    }, [teams])

    useEffect(() => {
        if (servicetech == null) {
            commonApi.GetServicetectList({
                pageNo: 1,
                pageSize: 1000
            }, (resp: any) => { }, (error: any) => { });
        }
    }, [servicetech])

    useEffect(() => {
        if (electricity == null) {
            //commonApi.GetServiceprovidertList({ ServieTypeID: 1 }, (resp: any) => { }, (error: any) => { });
            vendorApi.FilteredServiceProviderListRedux({ vendorIDs: [], vendorServiceTypeIDs: [1], vendorServiceTypeExcludeIDs: [], partsIDs: [], searchParam: `` }, (resp: any) => { }, (error: any) => { });
        }
    }, [electricity])

    useEffect(() => {
        if (gas == null) {
            //commonApi.GetServiceprovidertList({ ServieTypeID: 2 }, (resp: any) => { }, (error: any) => { });
            vendorApi.FilteredServiceProviderListRedux({ vendorIDs: [], vendorServiceTypeIDs: [3], vendorServiceTypeExcludeIDs: [], partsIDs: [], searchParam: `` }, (resp: any) => { }, (error: any) => { });
        }
    }, [gas])

    useEffect(() => {
        if (water == null) {
            //commonApi.GetServiceprovidertList({ ServieTypeID: 3 }, (resp: any) => { }, (error: any) => { });
            vendorApi.FilteredServiceProviderListRedux({ vendorIDs: [], vendorServiceTypeIDs: [4], vendorServiceTypeExcludeIDs: [], partsIDs: [], searchParam: `` }, (resp: any) => { }, (error: any) => { });
        }
    }, [water])

    useEffect(() => {
        if (telephone == null) {
            //commonApi.GetServiceprovidertList({ ServieTypeID: 4 }, (resp: any) => { }, (error: any) => { });
            vendorApi.FilteredServiceProviderListRedux({ vendorIDs: [], vendorServiceTypeIDs: [2], vendorServiceTypeExcludeIDs: [], partsIDs: [], searchParam: `` }, (resp: any) => { }, (error: any) => { });
        }
    }, [telephone])

    const [processingoption, setProcessingoption] = useState<any>(null);
    const [sagefacilityoption, setSagefacilityoption] = useState<any>(null);
    const [countyoption, setCountyoption] = useState<any>(null);
    const [cityoption, setCityoption] = useState<any>(null);
    const [locations, setLocations] = useState<any>(null);
    const [facilityCode, setFacilityCode] = useState<any>(null);
    const [working, setWorking] = useState<boolean>(false);

    const { control, getValues, reset, setValue, handleSubmit, formState: { errors }, watch } = useForm<FormValues>();

    const stateWatch = watch('stateID');
    const countyWatch = watch('countyID');

    const onSubmit: SubmitHandler<FormValues> = data => {
        console.log('Submitting with coordinates - lat:', latitude, 'lng:', longitude);

        let payload: any = {
            "facilityCode": facilityCode,
            "facilityName": data.facilityName,
            "processingFacilityID": data.processingFacilityID?.value,
            "addressLine1": data.addressLine1,
            "addressLine2": data.addressLine2,
            "countryID": '1',
            "stateID": data.stateID.value,
            "countyID": data.countyID.value,
            "cityID": data.cityID.value,
            "zipCode": data.zipCode,
            "area": data.area,
            "noOfRanches": data.noOfRanches,
            "electricityVendorServiceTypeID": data.electricityVendorServiceTypeID?.value,
            "natGasVendorServiceTypeID": data.natGasVendorServiceTypeID?.value,
            "waterAuthrityVendorServiceTypeID": data.waterAuthrityVendorServiceTypeID?.value,
            "isP_TelephoneVendorServiceTypeID": data.isP_TelephoneVendorServiceTypeID?.value,
            "latitude": latitude || null,
            "longitude": longitude || null,
            /*  "facilityManagerList": data.facilityManagerList?.map((item: any) => {
                 return {
                     "userID": item.value
                 }
             }), */
            "facilityManagerList": data.facilityManagerList && typeof data.facilityManagerList !== 'undefined' && Array.isArray(data.facilityManagerList) ? data.facilityManagerList.map((item: any) => ({
                userID: item?.value
            })) : [],
            "facilityServiceTechList": data.facilityServiceTechList && typeof data.facilityServiceTechList !== 'undefined' && Array.isArray(data.facilityServiceTechList) ? data.facilityServiceTechList.map((item: any) => {
                return {
                    "serviceTechID": item.value
                }
            }) : [],
            "facilityTeamList": data.facilityTeamList && typeof data.facilityTeamList !== 'undefined' && Array.isArray(data.facilityTeamList) ? data.facilityTeamList.map((item: any) => {
                return {
                    "teamID": item.value
                }
            }) : [],
            "sageFacilityID": data.sageFacilityID?.value,
        }
        if (editID) {
            payload['facilityID'] = editID
        }

        // Log warning if coordinates are missing
        if (!latitude || !longitude) {
            console.warn('Warning: Latitude or longitude is missing/null');
        }

        showLoader();
        setWorking(true);
        facilityApi.saveFacility(payload, (resp: any) => {
            console.log('update check image', !Array.isArray(data?.taxMapImage), data?.taxMapImage);
            if (typeof data?.taxMapImage == 'object' && !Array.isArray(data?.taxMapImage) && data?.taxMapImage) {
                const formData = new FormData();
                formData.append('inputFile', data.taxMapImage);
                formData.append('facilityID', editID ? editID : resp?.returnID);
                facilityApi.SaveFacilityImage(formData, (resp: any) => {
                    toast.success(resp?.message)
                    onCreate();
                    formReset();
                    hideLoader();
                    setWorking(false);
                    setEditData(null);
                }, (error: any) => {
                    hideLoader();
                    toast.error(error);
                    setWorking(false);
                });
            } else {
                toast.success(resp?.message)
                onCreate();
                formReset();
                hideLoader();
                setWorking(false);
                setEditData(null);
            }

        }, (error: any) => {
            hideLoader();
            toast.error(error);
            setWorking(false);
        });
    };

    const getProcessingFacilityList = () => {
        const payload = {};
        facilityApi.getProcessingFacilityList(payload, (resp: any) => {
            let processingdiop: any = [];
            resp.processingFacilityShortList?.map((facilist: any) => {
                processingdiop.push({
                    label: facilist.processingFacilityName,
                    value: facilist.processingFacilityID,
                })

                setProcessingoption(processingdiop);

            });


        }, (error: any) => {
            toast.error(error);
        });
    };
    const getSageFacilityList = () => {
        const payload = {};
        sageApi.getSageFacilityList(payload, (resp: any) => {
            let sagefacilityoption: any = [];
            resp.facilityList?.map((facilist: any) => {
                sagefacilityoption.push({
                    label: facilist.facilityName,
                    value: facilist.facilityID,
                })
                setSagefacilityoption(sagefacilityoption);
            });
        }, (error: any) => {
            toast.error(error);
        });
    };

    const getFacilityCode = () => {
        const payload = {};
        facilityApi.getFacilityCode(payload, (resp: any) => {
            setFacilityCode(resp.code)
        }, (error: any) => {
            toast.error(error);
        });
    };

    const getCountyList = (_StateId: any) => {
        const payload = {
            StateId: _StateId
        };
        commonApi.GetCountyList(payload, (resp: any) => { // get county list 
            let countylistoption: any = resp?.countyList?.map((countylist: any) => {
                return {
                    label: countylist.countyName,
                    value: countylist.cuntyID,
                }
            });
            setCountyoption(countylistoption);
            if (editData) {
                console.log("fsdfdsfsdfsf", editData.cuntyName);
                setValue('countyID', getSelectedOption(editData.cuntyName, countylistoption, 'label'))
            }
            if (locations?.county) {
                setValue('countyID', getSelectedOption(locations.county, countylistoption, 'label'))
            } else {
                setLocations(null)
            }
        }, (error: any) => {
            console.log('getCountyList error', error);
            setLocations(null)
        });
    };

    const getcityList = (_CountyId: any, _StateId?: any) => {
        const payload = {
            StateId: _StateId ? _StateId : getValues('stateID')?.value,
            CountyId: _CountyId,
        };
        commonApi.GetCityList(payload, (resp: any) => {
            let citylistoption: any = resp?.cityList?.map((countylist: any) => {
                return {
                    label: countylist.cityName,
                    value: countylist.cityID,
                }
            });
            setCityoption(citylistoption);
            if (editData) {
                setValue('cityID', getSelectedOption(editData.cityName, citylistoption, 'label'))
            }
            if (locations?.city) {
                setValue('cityID', getSelectedOption(locations.city, citylistoption, 'label'))
            } else {
                setLocations(null)
            }
        }, (error: any) => {
            setLocations(null)
        });
    };

    const formReset = () => {
        setWorking(false);
        setEditData(null);
        setLocations(null);
        // Reset coordinates to null when creating new facility
        setLatitude(null);
        setLongitude(null);
        reset({
            facilityName: '',
            processingFacilityID: null,
            addressLine1: '',
            addressLine2: '',
            stateID: null,
            countyID: null,
            cityID: null,
            zipCode: '',
            area: '',
            noOfRanches: '',
            facilityManagerList: null,
            facilityServiceTechList: null,
            facilityTeamList: null,
            electricityVendorServiceTypeID: null,
            taxMapImage: '',
            sageFacilityID: null,
        });
    }

    const getFacilityData = () => {
        const payload = {
            facilityID: editID
        };
        facilityApi.getFacilityDetails(payload, (resp: any) => {
            setEditData(resp);
        }
            , (error: any) => {
                toast.error(error);
            }
        );
    }

    useEffect(() => {
        if (stateWatch) {
            setValue('countyID', null)
            setValue('cityID', null)
            getCountyList(stateWatch.value)
        }
    }, [stateWatch])

    useEffect(() => {
        if (countyWatch) {
            setValue('cityID', null)
            getcityList(countyWatch.value, stateWatch?.value)
        }
    }, [countyWatch])


    useEffect(() => {
        getFacilityCode()
        getProcessingFacilityList();
        getSageFacilityList();
    }, [])

    useEffect(() => {
        if (_ref?.current) {
            _ref.current.reset = formReset;
        }
    }, [_ref])

    useEffect(() => {
        if (editID) {
            getFacilityData();
        } else {
            formReset();
        }
    }, [editID])

    useEffect(() => {
        if (editData) {
            reset({
                facilityName: editData.facilityName,
                processingFacilityID: getSelectedOption(editData.processingFacilityID, processingoption),
                addressLine1: editData.addressLine1,
                addressLine2: editData.addressLine2,
                stateID: getSelectedOption(editData.stateID, states as any),
                // countyID: getSelectedOption(editData.countyID, countyoption),
                // cityID: getSelectedOption(editData.cityID, cityoption),
                zipCode: editData.zipCode,
                area: Number(editData.area),
                noOfRanches: Number(editData.noOfRanches),
                facilityManagerList: getSelectedOptions(editData.facilityManagerList?.map((data: any) => data.userID), facilityManagers ? facilityManagers : []),
                facilityServiceTechList: getSelectedOptions(editData.facilityServiceTechList?.map((data: any) => data.serviceTechID), servicetech ? servicetech : []),
                facilityTeamList: getSelectedOptions(editData.facilityTeamList?.map((data: any) => data.teamID), teams ? teams : []),
                isP_TelephoneVendorServiceTypeID: getSelectedOption(editData.isP_TelephoneVendorServiceTypeID, telephone ? telephone : []),
                waterAuthrityVendorServiceTypeID: getSelectedOption(editData.waterAuthrityVendorServiceTypeID, water ? water : []),
                electricityVendorServiceTypeID: getSelectedOption(editData.electricityVendorServiceTypeID, electricity ? electricity : []),
                natGasVendorServiceTypeID: getSelectedOption(editData.natGasVendorServiceTypeID, gas ? gas : []),
                taxMapImage: editData.fullFilePath,
                sageFacilityID: getSelectedOption(editData.sageFacilityID, sagefacilityoption),
            });
            // Set latitude and longitude from edit data
            if (editData.latitude) {
                setLatitude(editData.latitude);
            }
            if (editData.longitude) {
                setLongitude(editData.longitude);
            }
            console.log('editData..', editData);
            console.log('editData reset image..', editData.fullFilePath);
            console.log('editData coordinates - lat:', editData.latitude, 'lng:', editData.longitude);
        }
    }, [editData, processingoption, facilityManagers, teams, servicetech, electricity, gas, water, telephone])

    const [autocomplete, setAutocomplete] = useState<any>(null);

    const onLoad = (autocomplete: any) => {
        setAutocomplete(autocomplete);
    };

    const addressMap: any = {
        state: 'administrative_area_level_1',
        city: 'locality',
        county: 'administrative_area_level_2',
        zip: 'postal_code',
    }




    /* const onPlaceChanged = () => {
        if (autocomplete !== null) {
            const place = autocomplete.getPlace();

            if (!place || !place.address_components) {
                console.warn('No place data or address components found');
                return;
            }

            let state = place.address_components.find((address: any) => address.types[0] === 'administrative_area_level_1')?.short_name;
            let city = place.address_components.find((address: any) => address.types[0] === 'locality')?.short_name;
            let county = place.address_components.find((address: any) => address.types[0] === 'administrative_area_level_2')?.short_name?.replace('County', '')?.trim();
            let zip = place.address_components.find((address: any) => address.types[0] === 'postal_code')?.short_name;

            console.log('place', place);
            console.log('state', state);
            console.log('city', city);
            console.log('county', county);
            console.log('zip', zip);

            setLocations({
                state: state,
                city: city,
                county: county,
                zip: zip
            })

            if (state) {
                const stateOption = states?.find((item: any) => item.data.shortName === state);
                if (stateOption) {
                    setValue('stateID', stateOption);
                }
            }

            if (zip) {
                setValue('zipCode', zip);
            }

            setValue('addressLine1', place.formatted_address);

            // Extract coordinates with proper validation
            if (place.geometry && place.geometry.location) {
                const lat = typeof place.geometry.location.lat === 'function'
                    ? place.geometry.location.lat()
                    : place.geometry.location.lat;
                const lng = typeof place.geometry.location.lng === 'function'
                    ? place.geometry.location.lng()
                    : place.geometry.location.lng;

                console.log('Extracted coordinates - lat:', lat, 'lng:', lng);

                if (lat && lng) {
                    setLatitude(lat);
                    setLongitude(lng);
                } else {
                    console.warn('Invalid coordinates extracted from place');
                }
            } else {
                console.warn('No geometry or location data found in place');
            }
        } else {
            console.warn('Autocomplete is null');
        }
    }; */

const onPlaceChanged = () => {
    if (autocomplete !== null) {
        const place = autocomplete.getPlace();

        if (!place || !place.address_components) {
            console.warn('No place data or address components found');
            // Handle clearing or resetting state if necessary
            return;
        }

        // --- 1. Extract individual address components ---
        // Using `find` with `.includes()` is more reliable for handling different address structures
        const streetNumber = place.address_components.find(
            (address: any) => address.types.includes('street_number')
        )?.short_name || '';

        const route = place.address_components.find(
            (address: any) => address.types.includes('route')
        )?.short_name || '';

        const city = place.address_components.find(
            (address: any) => address.types.includes('locality')
        )?.short_name || '';

        const stateShortName = place.address_components.find(
            (address: any) => address.types.includes('administrative_area_level_1')
        )?.short_name || '';

        const county = place.address_components.find(
            (address: any) => address.types.includes('administrative_area_level_2')
        )?.short_name?.replace('County', '').trim() || '';

        const zip = place.address_components.find(
            (address: any) => address.types.includes('postal_code')
        )?.short_name || '';

        const countryShortName = place.address_components.find(
            (address: any) => address.types.includes('country')
        )?.short_name || '';

        // --- 2. Construct the full address string ---
        // Create an array of components and join them, filtering out any empty ones.
        const fullAddress = [
            `${streetNumber} ${route}`.trim(),
            city,
            `${stateShortName} ${zip}`.trim(),
            countryShortName,
        ].filter(Boolean).join(', ');

        // --- 3. Update the form state with `react-hook-form` ---
        setValue('addressLine1', fullAddress);

        // --- 4. Update any other state variables ---
        setLocations({
            state: stateShortName,
            city: city,
            county: county,
            zip: zip
        });

        // --- 5. Update other form fields if needed ---
        if (stateShortName) {
            const stateOption = states?.find((item: any) => item.data.shortName === stateShortName);
            if (stateOption) {
                setValue('stateID', stateOption);
            }
        }
        if (zip) {
            setValue('zipCode', zip);
        }

        // --- 6. Extract and set coordinates ---
        if (place.geometry?.location) {
            const lat = typeof place.geometry.location.lat === 'function' ? place.geometry.location.lat() : place.geometry.location.lat;
            const lng = typeof place.geometry.location.lng === 'function' ? place.geometry.location.lng() : place.geometry.location.lng;

            if (lat && lng) {
                setLatitude(lat);
                setLongitude(lng);
            } else {
                console.warn('Invalid coordinates extracted from place');
            }
        } else {
            console.warn('No geometry or location data found in place');
        }

        // --- 7. Log results for debugging ---
        console.log('Constructed fullAddress:', fullAddress);
        console.log('place object:', place);
        
    } else {
        console.warn('Autocomplete is null');
    }
};



    return (
        <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className='flex flex-col h-full'>
            <div className='flex-1 overflow-auto'>

                <Controller
                    name='facilityName'
                    control={control}
                    rules={{ required: 'Facility name is required' }}
                    render={({ field: { value, onChange } }) => (
                        <Input
                            label='Facility Name'
                            type='text'
                            value={value}
                            onChange={onChange}
                            required
                            placeholder='Write Facility Name Here'
                            error={errors.facilityName?.message}
                        />
                    )}
                />

                <Controller
                    name='processingFacilityID'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            label='Select Processing Facility'
                            value={value}
                            onChange={onChange}
                            placeholder='Choose Processing Facility'
                            options={processingoption}
                            error={errors?.processingFacilityID?.message as any}
                        />
                    )}
                />

                {/* <LoadScript googleMapsApiKey={MAP_KEY} libraries={['places']}>
                    <Controller
                        name="addressLine1"
                        rules={{ required: 'Address required' }}
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <div>
                                <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                                    <Input
                                        label='Address Line 1'
                                        type='text'
                                        value={value}
                                        onChange={onChange}
                                        placeholder='Write Address Here'
                                        error={errors?.addressLine1?.message as any}
                                    />
                                </Autocomplete>
                            </div>
                        )}
                    />


                </LoadScript> */}
                {isLoaded && (
                    <Controller
                        name="addressLine1"
                        rules={{ required: 'Address required' }}
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <div>
                                <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                                    <Input
                                        label='Address Line 1'
                                        type='text'
                                        value={value}
                                        onChange={onChange}
                                        placeholder='Write Address Here'
                                        error={errors?.addressLine1?.message as any}
                                    />
                                </Autocomplete>
                            </div>
                        )}
                    />
                )}

                {/* <Controller
                    name="addressLine1"
                    rules={{ required: 'Address required' }}
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <div>

                            <Label text='Address Line 1'  />
                            <GooglePlacesAutocomplete
                                apiKey={MAP_KEY}// Replace with your API Key
                                selectProps={{
                                    value: value,
                                    onChange: (selectedAddress: any) => {
                                        onChange(selectedAddress);
                                        console.log('~~~~ on address select ~~~~~>', selectedAddress.value?.geometry?.location?.lat());
                                        setLatitude(40.710255);
                                        setLongitude(-74.005058);
                                    },
                                    placeholder: 'Write Address Here',
                                    styles: {
                                        control: (provided: any) => ({
                                            ...provided,
                                            width: '100%',
                                            height: '44px',
                                            marginTop: '8px',
                                            padding: '0 4px',
                                            borderRadius: '6px',
                                            border: `${errors.addressLine1?'2px solid #ef4444':'1px solid #d1d1d1'}`,
                                            fontSize: '14px',
                                            fontWeight: 400,
                                            color: '#333',
                                            boxShadow: 'none',
                                            '&:hover': {
                                                border: '1px solid #d1d1d1',
                                            },
                                        }),
                                        option: (provided: any) => ({
                                            ...provided,
                                            padding: '10px 15px',
                                            fontSize: '14px',
                                            fontWeight: 400,
                                            color: '#333',
                                            backgroundColor: '#fff',
                                            '&:hover': {
                                                backgroundColor: '#f9f9f9',
                                            },
                                        }),
                                        menu: (provided: any) => ({
                                            ...provided,
                                            fontWeight: 400,
                                            marginTop: '4px',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                            border: '1px solid #d1d1d1',
                                        }),
                                        singleValue: (provided: any) => ({
                                            ...provided,
                                            color: '#333',
                                        }),
                                    },
                                }}
                                debounce={500} // Optional: Adjust the debounce for auto-complete search
                                autocompletionRequest={{
                                    componentRestrictions: { country: 'us' }, // Optional: Restrict to specific country
                                }}

                            />
                            {errors?.addressLine1 && <Error message={errors?.addressLine1?.message as any} />}
                        </div>
                    )}
                /> */}

                <Controller
                    name='addressLine2'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <Input
                            label='Address Line 2'
                            type='text'
                            value={value}
                            onChange={onChange}
                            placeholder='Write Address Here'
                        />
                    )}
                />
                <div className='grid grid-cols-2 gap-2'> <Controller
                    name='stateID'
                    rules={{ required: 'State required' }}

                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            label='State'
                            value={value}
                            onChange={onChange}
                            required
                            placeholder='Choose State'
                            options={states ? states : []}
                            error={errors.stateID?.message as any}
                        />
                    )}
                />


                    <Controller
                        name='countyID'
                        rules={{ required: 'Country required' }}
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='County'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Choose County'
                                options={countyoption ? countyoption : []}
                                error={errors?.countyID?.message as any}
                            />
                        )}
                    />

                </div>
                <div className='grid grid-cols-2 gap-2'>
                    <Controller
                        name='cityID'
                        rules={{ required: 'City required' }}
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='City'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Choose City'
                                className='mt-6'
                                options={cityoption ? cityoption : []}
                                error={errors.cityID?.message as any}
                            />
                        )}
                    />

                    <Controller
                        name='zipCode'
                        rules={{ required: 'Zip code required' }}
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label='Zip Code'
                                type='text'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Write Zip Code Here'
                                error={errors.zipCode?.message as any}
                            />
                        )}
                    />

                </div>
                <div className='grid grid-cols-9 gap-2'>
                    <div className='col-span-4'>
                        <Controller
                            name='area'
                            rules={{ required: 'Area required' }}
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <Input
                                    label='Area'
                                    type='text'
                                    value={value}
                                    onChange={onChange}
                                    required
                                    placeholder='Enter Area in sqft'
                                    error={errors.area?.message as any}
                                />
                            )}
                        />

                    </div>
                    <div className='flex items-center justify-center mt-6'>sqft</div>
                    <div className='col-span-4'>
                        <Controller
                            name='noOfRanches'
                            rules={{ required: 'Ranch No required' }}
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <Input
                                    label='Ranch No'
                                    type='text'
                                    value={value}
                                    onChange={onChange}
                                    required
                                    placeholder='Ranch No'
                                    error={errors.noOfRanches?.message as any}
                                />
                            )}
                        />

                    </div>
                </div>
                <Controller
                    name='sageFacilityID'
                    rules={{ required: 'Sage Facility required' }}
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            label='Select Sage Facility'
                            value={value}
                            onChange={onChange}
                            required
                            placeholder='Choose Sage Facility'
                            options={sagefacilityoption}
                            error={errors?.sageFacilityID?.message as any}
                        />
                    )}
                />
                <Controller
                    name='taxMapImage'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <FileUpload
                            label='Upload Tax Map Image'
                            value={value}
                            accept=".jpg, .jpeg, .png"
                            onChange={(e: any) => {
                                onChange(e.target.files[0])
                            }}
                            placeholder='Choose Processing Facility'

                        />
                    )}
                />
                {/* <p className='text-[0.813rem] font-medium text-primary py-4'>2972 Westheimer Rd. Santa Ana, Illinois 85486 </p>
                <Button type="submit" working={false}>Upload Tax Map Image</Button>
                <div className='w-full mb-2 p-1 mt-4 border border-gray-300 rounded-md'>
                    <img className='' src={mapImg} alt="" />
                </div> */}
                <Controller

                    name='facilityManagerList'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            label='Facility Manager'
                            value={value}
                            onChange={onChange}
                            placeholder='Choose Facility Manager'
                            isMulti={true}
                            options={facilityManagers ? facilityManagers : []}
                            error={errors.facilityManagerList?.message as any}
                        />
                    )}
                />

                <Controller

                    name='facilityTeamList'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            //label='Select Teams'
                            label='Select Grower'
                            value={value}
                            isMulti={true}
                            onChange={onChange}
                            placeholder='Choose Team'
                            options={teams ? teams : []}
                            error={errors.facilityTeamList?.message as any}
                        />
                    )}
                />

                <Controller

                    name='facilityServiceTechList'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            label='Service Tech'
                            value={value}
                            isMulti={true}
                            onChange={onChange}
                            placeholder='Choose Service Tech'
                            options={servicetech ? servicetech : []}
                            error={errors.facilityServiceTechList?.message as any}
                        />
                    )}
                />

                

                <h4 className='font-semibold text-[0.938rem] pb-8 uppercase'>Utility Providers</h4>
                <div className='grid grid-cols-2 gap-2'>
                    <Controller

                        name='electricityVendorServiceTypeID'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Electricity'
                                value={value}
                                onChange={onChange}
                                placeholder='Choose Electricity'
                                className='mb-0'
                                options={electricity ? electricity : []}
                                error={errors.electricityVendorServiceTypeID?.message as any}
                            />
                        )}
                    />

                    <Controller

                        name='natGasVendorServiceTypeID'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Nat Gas'
                                value={value}
                                onChange={onChange}
                                placeholder='Choose Nat Gas'
                                className='mb-0'
                                options={gas ? gas : []}
                                error={errors.natGasVendorServiceTypeID?.message as any}
                            />
                        )}
                    />

                    <Controller

                        name='waterAuthrityVendorServiceTypeID'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Water Authority'
                                value={value}
                                onChange={onChange}
                                placeholder='Choose Water Authority'
                                options={water ? water : []}
                                error={errors.waterAuthrityVendorServiceTypeID?.message as any}
                            />
                        )}
                    />

                    <Controller

                        name='isP_TelephoneVendorServiceTypeID'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='ISP / Telephone'
                                value={value}
                                onChange={onChange}
                                placeholder='Choose ISP / Telephone'
                                options={telephone ? telephone : []}
                                error={errors.isP_TelephoneVendorServiceTypeID?.message as any}
                            />
                        )}
                    />

                </div>

            </div>
            <div className='flex justify-end gap-2 flex-shrink-0 border-t border-gray-200 pt-2'>
                <Button type="button" theme='secondary' onClick={() => {
                    setEditData(null);
                    formReset();
                    onCancel();
                }}>Cancel</Button>
                <Button type="submit" working={working}>Save</Button>
            </div>
        </form>
    );
};

export default CreateFacilities;